const actions = {
  SET_STATE: 'search/SET_STATE',
  LOAD: 'search/LOAD',
  LOADCQS: 'search/LOADCQS',
}

export default actions
